import { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { login } from '../api/auth';

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const isExpired = new URLSearchParams(location.search).get('expired') === '1';
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [keepLogin, setKeepLogin] = useState(true);

  // 이미 로그인된 경우 자동으로 대시보드로
  useEffect(() => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) {
          navigate('/dashboard');
        }
      } catch {}
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await login(form);
      const token = res.data.access_token;
      const user = JSON.stringify(res.data.user);
      if (keepLogin) {
        localStorage.setItem('token', token);
        localStorage.setItem('user', user);
      } else {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('user', user);
      }
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.detail || '로그인 실패');
    } finally { setLoading(false); }
  };

  const inp = { width: '100%', background: '#0F1117', border: '0.5px solid #2A3045', borderRadius: 8, padding: '10px 12px', color: '#E8ECF4', fontSize: 14, boxSizing: 'border-box' as const };

  return (
    <div style={{ minHeight: '100vh', background: '#0F1117', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#161B27', border: '0.5px solid #2A3045', borderRadius: 12, padding: '40px 36px', width: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ color: '#00D4AA', fontSize: 24, fontWeight: 700, margin: 0 }}>SellerRanky</h1>
          <p style={{ color: '#8892A4', fontSize: 13, marginTop: 8 }}>네이버 판매자를 위한 데이터 분석 도구</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', color: '#8892A4', fontSize: 12, marginBottom: 6 }}>이메일</label>
            <input type="email" required value={form.email}
              onChange={e => setForm({...form, email: e.target.value})} style={inp} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', color: '#8892A4', fontSize: 12, marginBottom: 6 }}>비밀번호</label>
            <input type="password" required value={form.password}
              onChange={e => setForm({...form, password: e.target.value})} style={inp} />
          </div>

          {/* 자동 로그인 체크박스 */}
          <div style={{ marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}
            onClick={() => setKeepLogin(k => !k)}>
            <div style={{ width: 18, height: 18, borderRadius: 4, border: `2px solid ${keepLogin ? '#00D4AA' : '#4A5568'}`, background: keepLogin ? '#00D4AA' : 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              {keepLogin && <span style={{ color: '#0A1F18', fontSize: 12, fontWeight: 900 }}>✓</span>}
            </div>
            <span style={{ color: '#8892A4', fontSize: 13 }}>로그인 상태 유지 (30일)</span>
          </div>

          {isExpired && <p style={{ color: '#F6AD55', fontSize: 13, marginBottom: 12, textAlign: 'center' as const }}>세션이 만료되었습니다. 다시 로그인해주세요.</p>}
      {error && <p style={{ color: '#F56565', fontSize: 13, marginBottom: 16 }}>{error}</p>}
          <button type="submit" disabled={loading}
            style={{ width: '100%', background: '#00D4AA', border: 'none', borderRadius: 8, padding: '12px', color: '#0A1F18', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 20, color: '#8892A4', fontSize: 13 }}>
          계정이 없으신가요? <Link to="/register" style={{ color: '#00D4AA' }}>회원가입</Link>
        </p>
      </div>
    </div>
  );
}
